<template>
    <div class="jr-component">
      <el-button v-bind="$attrs" :id="components.controlId" :type="type" :size="size" :icon="icon" :disabled="!components.controlRighttype || components.controlReadonly"  @click="click">
        <span><slot></slot></span>
      </el-button>
      <i @click="rightClick" v-if="badge & components.controlRighttype" class="el-icon-success jr-right-ico" style="color: green;"/>
      <i @click="rightClick" v-if="badge & !components.controlRighttype" class="el-icon-error jr-right-ico" style="color: red;"/>
    </div>
</template>
<script>
import store from '@/store'
export default {
  name: 'JrButton',
  props: {
    value: {},
    badge: {
      type: Boolean,
      default: false
    },
    components: {},
    type: {
      type: String,
      default: ''
    },
    size: {
      type: String,
      default: 'small'
    },
    icon: {
      type: String,
      default: ''
    }
  },
  methods: {
    rightClick(){
      this.$emit('badge-click', this.components.controlId, !this.components.controlRighttype)
    },
    click(){
      this.$emit('click')
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/componentsjr/JrButton.vue